import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import React, { memo } from 'react'

const ReadyButton = withStyles((theme) => ({
  root: {
    cursor: 'default',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
}))(Button)

const WaitButton = withStyles((theme) => ({
  root: {
    cursor: 'default',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.warning.main,
    '&:hover': {
      backgroundColor: theme.palette.warning.main,
    },
  },
}))(Button)

const PaidButton = withStyles((theme) => ({
  root: {
    cursor: 'default',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.success.main,
    '&:hover': {
      backgroundColor: theme.palette.success.main,
    },
  },
}))(Button)

const BadDebtButton = withStyles((theme) => ({
  root: {
    cursor: 'default',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.grey[900],
    '&:hover': {
      backgroundColor: theme.palette.grey[900],
    },
  },
}))(Button)

const CancelButton = withStyles((theme) => ({
  root: {
    cursor: 'default',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.grey[600],
    '&:hover': {
      backgroundColor: theme.palette.grey[600],
    },
  },
}))(Button)

function Chip({ title, status }) {
  switch (status) {
    case 'ready':
      return (
        <ReadyButton size="small" disableRipple>
          {title}
        </ReadyButton>
      )
    case 'wait':
      return (
        <WaitButton size="small" disableRipple>
          {title}
        </WaitButton>
      )
    case 'paid':
      return (
        <PaidButton size="small" disableRipple>
          {title}
        </PaidButton>
      )
    case 'bad_debt':
      return (
        <BadDebtButton size="small" disableRipple>
          {title}
        </BadDebtButton>
      )
    case 'cancel':
      return (
        <CancelButton size="small" disableRipple>
          {title}
        </CancelButton>
      )
    default:
      return null
  }
}

Chip.defaultProps = {
  title: '',
  status: '',
}

export default memo(Chip)
